<template lang="pug">
    v-container
        v-stepper(v-model="stepa")
            v-stepper-header
                v-stepper-step(
                    :complete="el > 1"
                    step="1"
                    ) Información General
                v-divider
                v-stepper-step(
                    :complete="el > 2"
                    step="2"
                    ) Información Comercial
                v-divider
                v-stepper-step(
                    :complete="el > 3"
                    step="3"
                    ) Información Inventario
            v-stepper-items
                v-stepper-content(step="1")
                    v-card
                        general-info-step(
                            v-model="item" 
                            :fields="gFields"
                            )
                v-stepper-content(step="2")
                    v-card
                        h1 sadfsafadsfsad
                v-stepper-content(step="3")
                    v-card
                        h1 sadfsafadsfsad
        //crud-form(
            ref="form"
            v-bind="formData"
            :fields="formFields"
            @calculate="calculateItemForm"
            @submitForm="submitForm( $event )"
            @autocompleteObjSelectId="callSubfamily($event)"
            )
</template>

<script>
//
import { mapActions } from 'vuex'
//
import { PromoForm } from '@/components/forms'
import CrudForm from '@/components/CrudForm/CrudForm'
import CurrencyUtils from '@/mixins/CurrencyUtils.js'
import InputValidations from '@/mixins/InputValidations.js'
//
import BranchOfficeService from '@/services/api/branchOffice'
import FamilyService from '@/services/api/family/FamilyServices'
import MeasurementUnitService from '@/services/api/unitMeasurement/UnitMeasurementService'
import ProductService from '@/services/api/product'
import SubFamilyService from '@/services/api/subfamily/SubfamilyService'
import TagService from '@/services/api/tag/TagServices'
import PromoService from '@/services/api/promo'
import SaleUtils from '@/services/SaleUtils'
//
import PromoFields from './fields'
import BranchFields from './fieldsBranch'
import ProductFields from './fieldsProduct'
//

/**
 * New Imports
 */
import GeneralFields from './tabs/FieldsGeneral'
export default {
    name: 'item-create',
    data: function() {
        //
        return {
            formData: {
                disabled: false,
                editable: false,
                submitText: 'crear producto',
                toolbarTitle: 'nuevo producto',
                toolbarIcon: 'close',
            },
            formData2: {
                disabled: false,
                editable: false,
                reset: false,
                submitText: 'actualizar precios',
                toolbarTitle: 'nueva promocion',
                toolbarIcon: 'close',
            },
            formProductsData: {
                reset: false,
                submitText: 'agregar producto',
            },
            formFields: PromoFields,
            formPricesFields: BranchFields,
            formFields3: ProductFields,
            listPrices: [],
            listProducts: [],
            selectedFamilyId: null,

            /**
             * newData
             */
            step: 1,
            item: {},
            gFields: GeneralFields,
        }
    },
    methods: {
        /**
         *
         */
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        /**
         *
         */
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        calculateItemForm(change) {
            if (change.vmodels.cost_price && change.vmodels.sale_price) {
                this.formFields = this.formFields.map(field => {
                    if (field.field === 'gains_margin') {
                        field.value = SaleUtils.getMargin(
                            change.vmodels.sale_price,
                            change.vmodels.cost_price
                        )
                    } else {
                        field.value = change.vmodels[field.field]
                    }
                    return field
                })
            }
            switch (change.field) {
                case 'wh_family_id':
                    return this.setSelectedFamilyId(change.value)
            }
        },

        /**
         *
         */
        calculatePrices(data, fields = {}) {
            //
            switch (data.field) {
                case 'g_branch_office_id':
                    fields = this.listPrices[data.value - 1]
                    break
                case 'cost_price':
                    fields['gain'] = SaleUtils.getGain(
                        data.vmodels.sale_price,
                        data.value
                    )
                    fields['gains_margin'] = SaleUtils.getMargin(
                        data.vmodels.sale_price,
                        data.value
                    )
                    break
                case 'sale_price':
                    fields['gain'] = SaleUtils.getGain(
                        data.value,
                        data.vmodels.cost_price
                    )
                    fields['gains_margin'] = SaleUtils.getMargin(
                        data.value,
                        data.vmodels.cost_price
                    )
                    break
            }

            //
            this.formPricesFields = this.formPricesFields.map(item => ({
                ...item,
                value:
                    fields[item.field] === undefined
                        ? data.vmodels[item.field]
                        : fields[item.field],
            }))
        },

        /**
         *
         */
        filterByFamilyId: wh_family_id => wh_subfamily =>
            wh_subfamily.wh_family_id === wh_family_id,

        /**
         *
         */
        generateErrorMessage(response) {
            //
            var message = ''
            var require = []
            //
            if (response.errors) {
                //
                this.formFields.forEach(field => {
                    //
                    if (response.errors.hasOwnProperty(field.field))
                        require.push(field.vuetifyProps.label)
                })

                //
                if (require.length > 0)
                    message = 'Campos incompletos: ' + require.join(', ')

                //
                if (response.errors.hasOwnProperty('products'))
                    message =
                        message +
                        'No se puede crear una promocion sin productos.'
            } else if (response.error) {
                //
                message = response.error
            }

            //
            return message
        },
        async callSubfamily(event) {
            //
            if (event.type == 'family') {
                let subFamily = await SubFamilyService.fetchAllSubfamilyByFamilyId(
                    event.id
                )
                this.setFieldOptionData(5, subFamily)
            }
            //
        },

        /**
         *
         */
        getProductFormField(index) {
            //
            return this.formFields[index] || {}
        },

        /**
         *
         */
        isPricesFromIncompleted() {
            //
            return (
                this.listPrices.length < 1 ||
                this.listPrices.some(price => price.upc_code === '')
            )
        },
        isPricesFromIncompleted() {
            //
            return (
                this.listPrices.length < 1 ||
                this.listPrices.some(price => price.upc_code === '')
            )
        },
        async refresh() {
            //this.$refs.form.refresh()
            this.$router.push('/products')
        },
        removeProduct(index) {
            //
            this.listProducts = [
                ...this.listProducts.slice(0, index),
                ...this.listProducts.slice(index + 1),
            ]
        },
        async responseForm(response) {
            switch (response.status) {
                case 'success':
                    return this.showSnackbar(
                        'success',
                        'Exito.',
                        'El producto fue creado exitosamente.',
                        this.refresh
                    )
                case 'error':
                    return this.showSnackbar(
                        'error',
                        'Error.',
                        this.generateErrorMessage(response)
                    )
            }
        },

        /**
         *
         */
        setSelectedFamilyId(wh_family_id) {
            //
            this.selectedFamilyId = wh_family_id
        },

        async showSnackbar(type, title, message, callback = () => {}) {
            this.initSnackbar(this.fillSnack(type, title, message, false, 3000))
            callback()
        },
        async submitForm(data) {
            let branch_office_data = [
                'g_branch_office_id',
                'cost_price',
                'sale_price',
                'gains_margin',
                'minimum_stock',
                'maximum_stock',
                'critical_stock',
            ]
            data.branch_office_data = []
            data.branch_office_data[0] = {}
            for (let key in data) {
                if (data.hasOwnProperty(key)) {
                    if (branch_office_data.includes(key)) {
                        data.branch_office_data[0][key] = data[key]
                        delete data[key]
                    }
                }
            }
            data.branch_office_data[0].g_branch_office_id = 1
            data.upc_codes = [data.upc_code]
            delete data.upc_code
            this.formFields.forEach(field => {
                if (field.type === 'checkbox') {
                    if (!data[field.field]) {
                        data[field.field] = false
                    }
                }
            })
            this.responseForm(await ProductService.createItem(data))

            // //
            // if ( !this.$refs.pricesForm.formIsValid ) return this.showSnackbar( 'error', 'Error.', 'El producto no posee precio.' )
            // //
            // if ( this.listPrices.some( price => price.upc_code === '' ) ) return this.showSnackbar( 'error', 'Error.', 'Complete los precios en todas las sucursales.' )
            // //
            // //return this.showSnackbar( 'error', 'Error.', 'ejemplo.' )
            // //
            // this.responseForm( await ProductService.createItem({
            //         ...data,
            //         branch_office_data: [
            //             ...this.listPrices.map( price => ({ ...price, upc_code: undefined }) )
            //         ],
            //         products: [
            //             ...this.listProducts
            //         ],
            //         upc_codes: [
            //             ...this.listPrices.map( price => price.upc_code )
            //         ]
            //     })
            // )
        },
        submitPrices(data) {
            //
            const index = this.listPrices.findIndex(
                price => price.g_branch_office_id === data.g_branch_office_id
            )
            //
            this.listPrices = [
                ...this.listPrices.slice(0, index),
                {
                    ...this.listPrices[index],
                    ...data,
                },
                ...this.listPrices.slice(index + 1),
            ]
            //
            this.showSnackbar(
                'info',
                'Guardado.',
                'Se establecieron los precios para el nuevo producto.'
            )
        },
        submitProducts(data) {
            //
            if (!data.wh_product_id)
                return this.showSnackbar(
                    'error',
                    'Error.',
                    'Seleccione un producto.'
                )
            //
            this.listProducts = [...this.listProducts, data]
            //
            this.showSnackbar(
                'info',
                'Guardado.',
                'Se agrego un producto para el nuevo item ( Pack o Promocion ).'
            )
        },
        setFieldOptionData(index, data) {
            this.formFields[index].options.data = data
        },
        setListPrices(data) {
            this.listPrices = data.map(branchOffice => ({
                g_branch_office_id: branchOffice.id,
                upc_code: '',
                cost_price: 0,
                sale_price: 0,
                gains_margin: 0,
                minimum_stock: 0,
                maximum_stock: 0,
                critical_stock: 0,
            }))
        },
        setPricesFieldOptionData(index, data) {
            this.formPricesFields[index].options.data = data
        },
        setProductsFieldOptionData(index, data) {
            this.formFields3[index].options.data = data
        },
    },
    components: {
        CrudForm,
    },
    mixins: [InputValidations, CurrencyUtils],
    // watch: {
    //     async selectedFamilyId(wh_family_id) {
    //         //
    //         this.setFieldOptionData(
    //             5,
    //             (await SubFamilyService.fetchAll()).filter(
    //                 this.filterByFamilyId(wh_family_id)
    //             )
    //         )
    //     },
    // },
    beforeMount: async function() {
        //
        this.setFieldOptionData(4, await FamilyService.fetchAll())
        this.setFieldOptionData(8, await MeasurementUnitService.fetchAll())
        this.setFieldOptionData(5, await SubFamilyService.fetchAll())
        this.setFieldOptionData(7, await TagService.fetchAll())
        //
        this.setPricesFieldOptionData(0, await BranchOfficeService.fetchAll())
        this.setListPrices(await BranchOfficeService.fetchAll())
        //
        this.setProductsFieldOptionData(0, await ProductService.fetchAll())
    },

    /**
     *
     */
    async mounted() {
        //
        this.$refs.form.$refs.form.reset()
        this.setTitleTopBar('Nuevo producto')
    },
}
</script>

<style>
.no-round {
    border-radius: 0;
}
</style>

